/**
 * Admin API (Bearer token, 与业务 session 互斥)。
 * token 来自 NF_ADMIN_TOKEN, 由用户在 admin 面板手动填; 不与 cookie 混用。
 */
import { ApiError, request } from './http'

const ADMIN_TOKEN_STORAGE_KEY = 'nf.admin_token'

function readStoredAdminToken(): string | null {
  try {
    return globalThis.localStorage?.getItem(ADMIN_TOKEN_STORAGE_KEY) ?? null
  } catch {
    return null
  }
}

function writeStoredAdminToken(token: string | null) {
  try {
    if (token) globalThis.localStorage?.setItem(ADMIN_TOKEN_STORAGE_KEY, token)
    else globalThis.localStorage?.removeItem(ADMIN_TOKEN_STORAGE_KEY)
  } catch {
    // localStorage 不可用时仍保留当前页面内的内存 token。
  }
}

let adminToken: string | null = readStoredAdminToken()

export function setAdminToken(token: string | null) {
  adminToken = token
  writeStoredAdminToken(token)
}

export function clearAdminToken() {
  adminToken = null
  writeStoredAdminToken(null)
}

export function getAdminToken(): string | null {
  return adminToken
}

/** admin 请求统一注入 Bearer */
export function adminRequest<T = unknown>(
  path: string,
  opts: Omit<Parameters<typeof request>[1], 'bearer'> = {},
): Promise<T> {
  if (!adminToken) return Promise.reject(new Error('admin token 未设置'))
  return request<T>(path, { ...opts, bearer: adminToken })
}

export async function verifyAdminToken(): Promise<boolean> {
  try {
    const response = await adminRequest<{ ok: boolean }>('/v1/admin/verify', { skipAuthRedirect: true })
    return response.ok === true
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) return false
    throw error
  }
}
